import DeviceManager from '../utils/device-manager';
import $ from "jquery";
import Flickity from "flickity-fade";
import "flickity-imagesloaded";

class HomeBlogSlider {
    constructor($el) {
        this.$el = $el;

        this.options = {
            autoPlay: true,
            pageDots: true,
            wrapAround: false,
            prevNextButtons: false,
            imagesLoaded: true,
            cellSelector: '.home-blog__single',
            cellAlign: 'left',
            groupCells: true
        };

        if(this.$el.length) {
            this._init();
            this._bindEvents();
        }
    }

    _init() {
        this.$slides = this.$el.find('.home-blog__single');
        this.slidesCount = this.$slides.length;

        if(this.slidesCount > 1 && document.body.clientWidth < 845) {
            this._createSlider();
            console.log('slider mobile');
        } else if(this.slidesCount > 3 && document.body.clientWidth >= 700 && document.body.clientWidth < 1200) {
            this._createSlider();
            console.log("slider tablet");
        } else if(this.slidesCount >= 4 && document.body.clientWidth >= 1200) {
            this._createSlider();
            console.log("no slider laptop");
        }
    }

    _bindEvents() {
        this._onBreakpointChangeFn = this._onBreakpointChange.bind(this);

        DeviceManager.on('device-manager:breakpointChange', this._onBreakpointChangeFn);
    }

    _destroy() {
        if(this.slider) {
            this.slider.destroy();
            this.slider = null;
        }
    }

    _onBreakpointChange() {
        if(document.body.clientWidth < 845 && this.slidesCount > 1){
            this._destroy();
            this._createSlider();
            console.log('slider resize mobile');
        } else if(this.slidesCount > 3 && document.body.clientWidth >= 700 && document.body.clientWidth < 1200) {
            this._destroy();
            this._createSlider();
            console.log('slider resize laptop');
        } else if(this.slidesCount >= 7 && document.body.clientWidth >= 1200) {
            this._destroy();
            console.log("no slider laptop");
        }
        
    }

	_createSlider() {
        this.slider = new Flickity(this.$el[0], this.options);
    }
    
}

export default HomeBlogSlider;
